var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.116 10.999L6 2.00001L4.884 10.998H1C0.448 10.998 0 10.539 0 10C0.00316508 9.73779 0.110239 9.50954 0.297721 9.32618C0.485203 9.14283 0.737774 8.99734 1 9.00001H3.116L4.016 1.71491C4.15 0.642905 5 0 6 0C7 0 7.871 0.824906 7.984 1.71491L8.88281 9.00001H10.857L12 16L13.142 9.00001H19C19.552 9.00001 20 9.46001 20 10C20 10.54 19.552 11 19 11H14.858L13.977 16.3439C13.9081 16.7586 13.7089 17.1405 13.4082 17.4344C13.1076 17.7282 12.7212 17.9186 12.305 17.9779C11.213 18.1429 10.192 17.4109 10.023 16.3439L9.143 11H7.115L7.116 10.999Z",
    fill: "#7B94BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.4af375cd2730280b7030095dd99ffe67.svg";
export { ForwardRef as ReactComponent };